<div *ngIf="dcmntsLst && dcmntsLst.length > 0">
    <div class="m-4">
        <button mat-flat-button [color]="'primary'" class="m-r-10" (click)="addNewDocument()">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:plus-circle'"></mat-icon>
            <span class="sm:inline-block ml-2">Image/Documents</span>
        </button>
    </div>
    <!-- <ds-loading *ngIf="loader === true"></ds-loading> -->
    <div class="flex flex-col w-full  m-2 cntntBgrnd">
        <div class="flex flex-col items-center p-2 sm:p-2">
            <div class="flex flex-col w-full">
                <mat-accordion class="w-full">
                    <ng-container *ngFor="let a of dcmntsLst">
                        <mat-expansion-panel class="bg-gray-50 dark:bg-gray-700">
                            <mat-expansion-panel-header [collapsedHeight]="'56px'">
                                <mat-panel-title class="font-medium leading-tight capitalize">{{a.dcmnt_ctgry_nm}}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="grid grid-cols-1  sm:grid-cols-2 lg:grid-cols-4  w-full">
    
                                <div class=" m-2  shadow p-4 bg-white rounded-lg"
                                    *ngFor="let a of a.entyDcmnts; let k = index">
                                    <div *ngIf="a.dcmnt_type_nm == 'Image'" class="p-1 cursor-pointer">
                                        <a [href]="a.dcmnt_url_tx" style="text-decoration: none;text-align: center;" [matTooltip]="'Click to  download Image'">
                                            <img [src]="a.dcmnt_url_tx" style="width:auto;height:85px" class="m-auto"/>
                                        </a>
                                    </div>
                                    <div *ngIf="a.dcmnt_type_nm == 'PDF'" class="p-1">
                                        <a [href]="a.dcmnt_url_tx" style="text-decoration: none;text-align: center;" [matTooltip]="'Click to  download PDF'">
                                            <img src="assets/images/support/pdf.png" style="width:auto;height:85px" class="m-auto">
                                        </a>
                                    </div>
                                    <div *ngIf="a.dcmnt_type_nm == 'Word'" class="p-1">
                                        <a [href]="a.dcmnt_url_tx" style="text-decoration: none; text-align: center;" [matTooltip]="'Click to download Document'">
                                            <img src="assets/images/support/docx.png" style="width:auto;height:85px" class="m-auto">
                                        </a>
                                    </div>
                                    <div *ngIf=" a.dcmnt_type_nm == 'Excel'" class="p-1">
                                        <a [href]="a.dcmnt_url_tx" style="text-decoration: none; text-align: center;" [matTooltip]="'Click to download Excel'">
                                            <img src="assets/images/support/excel.png" style="width:auto;height:85px" class="m-auto">
                                        </a>
                                    </div>
                                    <div class=" text-xs p-1 break-all capitalize">
                                        {{a.dcmnt_nm}}
                                    </div>
                                    <span>
                                        <mat-icon class="icon-size-4 cursor-pointer" style="float: right;"
                                            [svgIcon]="'heroicons_solid:pencil-alt'" (click)="edtDcmnt(a)">
                                        </mat-icon>
                                    </span>
                                    <div class=" text-xs p-1">
                                        {{a.u_ts ? a.u_ts :a.i_ts}}
                                    </div>
                                </div>
                            </div>
                        </mat-expansion-panel>
                    </ng-container>
                </mat-accordion>
            </div>
        </div>
    </div>
</div>
